import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from 'bi-modules';
import { ErrorDetailsService } from 'bi-modules';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler{

  constructor(private loggerService: LoggerService, private errorDetailsService: ErrorDetailsService, private translateService: TranslateService) { }

  handleError(error:  any) {  
    console.log(error);
  }
}
